let grid_taks_ini = function() {
    // this.autoHeigthAllTask();
    let divisor = this.grip_taks_divisor(window.innerWidth);
    this.grid_taks_generator(divisor);
    this.grid_taks_resize();
    let d = new Date();
};
export default grid_taks_ini;
